import type { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

const lineReturn = { br: <br /> };

export function Awaiting({ forceTradeable }: { forceTradeable: boolean }): ReactElement {
  return (
    <div
      className="d-flex flex-column justify-content-between border-top border-bottom bg-lvl2 h-100"
      data-e2e="price-awaiting"
    >
      <div className="d-flex justify-content-center align-items-center h-100">
        <span className=" text-center fw-semibold text-secondary">
          <FormattedMessage
            id={`flexiForwardTile.rates.${forceTradeable ? 'executable' : 'indicative'}.PENDING`}
            values={lineReturn}
          />
        </span>
      </div>
    </div>
  );
}
